import { getLocalApi } from "./localApi";
import { Languages } from "app/shared/model";
import apiConfig from "app/api/apiConfig.json";

export async function getAllLanguages() : Promise<Languages[]> {
    const localApi = await getLocalApi();

    return await localApi.fetchList(apiConfig.reference_data_get_course_languages, (dto:any) => ({
        name: dto.name,
        id: dto.id
    }), 'Unable to fetch Languages')
}